import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import UserList from './UserList';
import UserForm from './UserForm';
import WorkoutManager from './WorkoutManager';

/**
 * Pagina dedicata "Utenti e schede" (ex tab nell'Admin Panel).
 * Gestione utenti, modifica e assegnazione schede.
 */
const AdminUsersPage = () => {
  const [editUser, setEditUser] = useState(null);
  const [showWorkoutManager, setShowWorkoutManager] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [workoutMode, setWorkoutMode] = useState('view');
  const [initialWorkout, setInitialWorkout] = useState(null);
  const { isAdmin, isTrainer } = useAuth();
  const { t } = useTranslation();

  const handleEditUser = (user) => setEditUser(user);
  const handleCloseUserForm = () => setEditUser(null);
  const handleUserSaved = () => setEditUser(null);

  const handleCreateWorkout = (user, mode = 'new', workout = null) => {
    let workoutData = workout;
    if (mode === 'edit' && workout) {
      workoutData = { ...workout, scheda_id: workout.scheda_id || workout.id };
    }
    setSelectedUser(user);
    setWorkoutMode(mode);
    setInitialWorkout(workoutData);
    setShowWorkoutManager(true);
  };

  const handleCloseWorkoutManager = () => {
    setShowWorkoutManager(false);
    setSelectedUser(null);
    setInitialWorkout(null);
  };

  return (
    <div className="p-6 max-w-[1700px] mx-auto">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
        {isAdmin() ? t('admin.panel.tabs.gymsAndWorkouts') : t('admin.panel.tabs.clientsAndWorkouts')}
      </h1>

      {editUser ? (
        <UserForm
          user={editUser}
          onClose={handleCloseUserForm}
          onSuccess={handleUserSaved}
        />
      ) : (
        <UserList
          onEditUser={handleEditUser}
          onCreateWorkout={handleCreateWorkout}
        />
      )}

      {showWorkoutManager && selectedUser && (
        <WorkoutManager
          user={selectedUser}
          onClose={handleCloseWorkoutManager}
          mode={workoutMode}
          initialWorkout={initialWorkout}
        />
      )}
    </div>
  );
};

export default AdminUsersPage;
